module.exports = "<nv-react-component component=\"PracticeRoom\"></nv-react-component>";